<template>
  <section class="categories" v-if="categories.length >= 1">
    <div class="container">
      <h2 class="section-title">Shop by Category</h2>

      <div class="scroll-wrapper">
        <div class="scroll-content">
          <div v-for="(category, i) in displayCategories" :key="i" class="category-card horizontal">
            <img :src="imagePathManager(category.image)" :alt="category.image">
            <h3 style="overflow: hidden;">{{ category.subCategory }}</h3>
            <span>{{ category.component }}</span>
          </div>
        </div>
      </div>
      <router-link to="/products/categories">
        <button :title="'All Categories : ' + categories.length"
          style="width: 150px; padding: 10px 30px; background-color: green; border: none; color: #fff; border-radius: 5px;">
          Show more {{ categories.length < 12 ? "" : categories.length >= 100 ? '99+' : categories.length - 11 }}
        </button>
      </router-link>
      <!-- <div class="category-grid">
        <div v-for="(category, i) in displayCategories" :key="i" class="category-card">
          <img :src="imagePathManager(category.image)" :alt="category.image">
          <h3>{{ category.subCategory }} {{ category.component }}</h3>
        </div>
        <div v-if="categories.length > 12" class="category-card">
          <router-link to="/products/categories">
            <i v-if="!showAll" class="fas fa-plus-circle" style="font-size: 100px; color: #2e7d32;"></i>
            <span :title="'All Categories : ' + categories.length">
              Show more {{ categories.length >= 100 ? '99+' : categories.length - 11 }}
            </span>
          </router-link>
        </div>
      </div> -->
    </div>
  </section>
</template>

<script>
// import imgSrc from '@/assets/images/image-broken.svg';
import { PostRequest, ConnectionPath } from '@/network';

export default {
  name: 'CategoriesSection',
  data() {
    return {
      showAll: false,
      categories: []
    }
  },
  created() {
    this.loadSubCategory();
  },
  computed: {
    displayCategories() {
      if (!this.categories || this.categories.length === 0) return [];

      let shuffled = [...this.categories].sort(() => Math.random() - 0.5);
      let maxItems = this.categories.length <= 12 ? this.categories.length : 12;

      return this.showAll ? this.categories : shuffled.slice(0, maxItems);

    }
  },
  methods: {
    imagePathManager(imgPath) {
      try {
        const url = new URL(imgPath);
        const isUrl = url.protocol === "http:" || url.protocol === "https:";
        if (isUrl) {
          return imgPath;
        } else {
          return ''
        }

      } catch (_) {
        const path = `${ConnectionPath().api}/components_img/${imgPath}`
        return path;
      }

    },
    async loadSubCategory() {
      var items = await PostRequest(`/api/sub-category/list-sub-category`, null, '', '');
      if (items.status === 200) {
        this.categories = items.data
      } else {
        this.categories == null
      }
    },
  }
}
</script>

<style scoped>
.category-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 16px;
}

.category-card {
  background-color: #f9f9f9;
  padding: 16px;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.see-more {
  grid-column: span 2;
  text-align: center;
}

.see-more button {
  padding: 8px 16px;
  background-color: #007bff;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.see-more button:hover {
  background-color: #0056b3;
}

.categories {
  padding: 60px 0;
}

.category-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  gap: 20px;
}

.category-card {
  background-color: var(--white);
  border-radius: var(--border-radius);
  padding: 20px;
  text-align: center;
  box-shadow: var(--box-shadow);
  transition: var(--transition);
}

.category-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
}

.category-card img {
  width: 80px;
  height: 80px;
  margin-bottom: 15px;
}

.category-card h3 {
  font-size: 16px;
  font-weight: 600;
  color: var(--text-color);
}

@media (max-width: 1200px) {
  .category-grid {
    grid-template-columns: repeat(4, 1fr);
  }
}

@media (max-width: 992px) {
  .category-grid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 768px) {
  .category-grid {
    grid-template-columns: repeat(2, 1fr);
  }
}

@media (max-width: 576px) {
  .category-grid {
    grid-template-columns: 1fr;
  }
}


.scroll-wrapper {
  overflow-x: auto;
  white-space: nowrap;
  scroll-behavior: smooth;
  padding: 20px 0;
  -ms-overflow-style: none;
}

.scroll-wrapper::-webkit-scrollbar {
  display: none;
}

.scroll-content {
  display: flex;
  gap: 20px;
  animation: scrollX 40s linear infinite;
}

.category-card.horizontal {
  display: inline-block;
  min-width: 160px;
  background-color: var(--white);
  border-radius: var(--border-radius);
  padding: 20px;
  text-align: center;
  box-shadow: var(--box-shadow);
  transition: var(--transition);
}

@keyframes scrollX {
  0% {
    transform: translateX(0%);
  }

  50% {
    transform: translateX(-50%);
  }

  100% {
    transform: translateX(0%);
  }
}

/* Optional: Pause on hover */
.scroll-wrapper:hover.scroll-content {
  animation-play-state: paused;
}
</style>